const _window = window as (typeof window & { salesysTabId: string; });

if (!_window.salesysTabId) {
  _window.salesysTabId = `tab-${Date.now()}-${Math.random().toString(24).substring(2)}`;
}

/**
 * @returns The ID of the current browser tab.
 */
export function getTabId() {
  return _window.salesysTabId;
}

if (!document.hidden) {
  window.localStorage.setItem('latestFocusedTab', getTabId());
}

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    window.localStorage.setItem('latestFocusedTab', getTabId());
  }
});

window.addEventListener('unload', () => {
  localStorage.removeItem(_window.salesysTabId);
});

window.addEventListener('beforeunload', () => {
  localStorage.removeItem(_window.salesysTabId);
});

/**
 * Whether this tab was the latest to focus.
 */
export function isTabLatestFocused() {
  return window.localStorage.getItem('latestFocusedTab') === getTabId();
}